import React from 'react';
import ReactDOM from 'react-dom/client';

import AccomondationSearchCampaign from './AccomondationSearchCampaign';

const root = ReactDOM.createRoot(
  document.getElementById('accommodation_search_campaign')
);

root.render(
  <React.StrictMode>
    <AccomondationSearchCampaign />
  </React.StrictMode>
);
